"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDynamicColumnsList = useDynamicColumnsList;
const hooks_1 = require("../../../../ui/hooks");
const utils_1 = require("../../../../ui/utils");
const swr_1 = __importDefault(require("swr"));
function useDynamicColumnsList(request) {
    const dynamicColumnClient = (0, hooks_1.useDynamicColumnClient)();
    const mappedStorageRequest = {
        ...request.filterData,
        offset: request.offset,
        limit: request.limit,
    };
    const response = (0, swr_1.default)(['dynamicColumnList', mappedStorageRequest], async ([, request]) => {
        return dynamicColumnClient.listColumns(request);
    }, {
        use: [utils_1.laggy],
        revalidateOnFocus: false,
    });
    return {
        ...response,
        data: response.data
            ? {
                rows: response.data.rows,
                filteredRowCount: response.data.total,
            }
            : undefined,
        reload: response.mutate,
    };
}
